module.exports = function() {
  return new Worker(__webpack_public_path__ + "747e248a0647813e4364.worker.js");
};